module.exports = __webpack_public_path__ + "img/2.a927e99f.png";